module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/icon-apple-store_f68f914.png";